import ax from '../../axios'

/**
 * 获取客服评价
 * @param {*} params 
 */
export function getServiceReportAPI (params) {
  return ax({
    url: '/wlapi/evaluate/evaluateCountList',
    method: 'POST',
    params,
  })
}
/**
 * 差评导出
 * @param {*} params 
 */
export function outputPoorServiceReportAPI (params) {
  return ax({
    url: '/wlapi/evaluate/poorEvaluateOutExcel',
    method: 'POST',
    params,
  })
}